// extracted by mini-css-extract-plugin
module.exports = {"container":"HeaderText_container__AzjPK"};